import {
  normalizarRespuestaPaginaPrincipal,
  type ObjetoEditable,
} from 'views/components/crm/components/sitio_web/composables/pagina_principal_editor';

type HttpCliente = {
  post: (
    url: string,
    body?: unknown,
    options?: unknown,
  ) => Promise<{ body?: unknown }>;
};

export async function cargarPaginaPrincipal(
  httpClient: HttpCliente,
  baseUrl: string,
) {
  const respuesta = await httpClient.post(
    `${baseUrl}website_dir/pagina_principal/getDatosPaginaPrincipal`,
  );

  return normalizarRespuestaPaginaPrincipal(respuesta.body);
}

export async function guardarPaginaPrincipal(
  httpClient: HttpCliente,
  baseUrl: string,
  principal: ObjetoEditable,
  secciones: ObjetoEditable,
) {
  await httpClient.post(`${baseUrl}website_dir/pagina_principal/save`, {
    principal,
    propiedades: secciones,
  });
}